export const getAvatarImageURL = (userId) => {
  if (process.env.NODE_ENV === 'production')
    return `${process.env.REACT_APP_PROD_API_URL}/users/${userId}/avatar`;

  if (window.location.hostname === '192.168.1.7')
    return `http://192.168.1.7:8080/users/${userId}/avatar`;

  return `${process.env.REACT_APP_DEV_API_URL}/users/${userId}/avatar`;
};

export const getVideoSource = (userId) => {
  if (process.env.NODE_ENV === 'production')
    return `${process.env.REACT_APP_PROD_API_URL}/users/me/request/video?userId=${userId}`;

  if (window.location.hostname === '192.168.1.7')
    return `http://192.168.1.7:8080/users/me/request/video?userId=${userId}`;

  return `${process.env.REACT_APP_DEV_API_URL}/users/me/request/video?userId=${userId}`;
};

export const getImageRequestSource = (userId) => {
  if (process.env.NODE_ENV === 'production')
    return `${process.env.REACT_APP_PROD_API_URL}/users/me/request/image?userId=${userId}`;

  if (window.location.hostname === '192.168.1.7')
    return `http://192.168.1.7:8080/users/me/request/image?userId=${userId}`;

  return `${process.env.REACT_APP_DEV_API_URL}/users/me/request/image?userId=${userId}`;
};
